import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    StartTime: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' }
        ]
      },
      bustype: {
        validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
            {
            type: 'label',
            size: 'Medium',
            label: 'Kindly fill up the form and one of our team member will be in touch to discuss a custom proposal for your event needs.  Let us tailor a unique experience, and discover a smooth, seamless process for planning your next event with Kalei\’s Kitchenette.',
            mapping: 'headerLabel',
            customClasses: ['header']
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What Type of Event/Occasion?:*',
            options: [
              { label: 'Meeting', value: 'Meeting' },
              { label: 'Wedding/Anniversary', value: 'Wedding/Anniversary' },
              { label: 'Retirement', value: 'Retirement' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Office', value: 'Office' },
              { label: 'Other', value: 'Other' },
          ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event/Occasion?:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location of Event/Occasion?:*',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How Many Guests?:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
       {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Time of Event/Occasion?:*',
                    options: [
                        { label: '7:30 AM', value: '07:30:00' },
                        { label: '8:00 AM', value: '08:00:00' },
                        { label: '8:30 AM', value: '08:30:00' },
                        { label: '9:00 AM', value: '09:00:00' },
                        { label: '9:30 AM', value: '09:30:00' },
                        { label: '10:00 AM', value: '10:00:00' },
                        { label: '10:30 AM', value: '10:30:00' },
                        { label: '11:00 AM', value: '11:00:00' },
                        { label: '11:30 AM', value: '11:30:00' },
                        { label: '12:00 PM', value: '12:00:00' },
                        { label: '12:30 PM', value: '12:30:00' },
                        { label: '1:00 PM', value: '13:00:00' },
                        { label: '1:30 PM', value: '13:30:00' },
                        { label: '2:00 PM', value: '14:00:00' },
                        { label: '2:30 PM', value: '14:30:00' },
                        { label: '3:00 PM', value: '15:00:00' },
                        { label: '3:30 PM', value: '15:30:00' },
                        { label: '4:00 PM', value: '16:00:00' },
                        { label: '4:30 PM', value: '16:30:00' },
                        { label: '5:00 PM', value: '17:00:00' },
                        { label: '5:30 PM', value: '17:30:00' },
                        { label: '6:00 PM', value: '18:00:00' },
                        { label: '6:30 PM', value: '18:30:00' },
                        { label: '7:00 PM', value: '19:00:00' },
                        { label: '7:30 PM', value: '19:30:00' },
                        { label: '8:00 PM', value: '20:00:00' },
                        { label: '8:30 PM', value: '20:30:00' },
                        { label: '9:00 PM', value: '21:00:00' },
                        { label: '9:30 PM', value: '21:30:00' },
                        { label: '10:00 PM', value: '22:00:00' },
                        { label: '10:30 PM', value: '22:30:00' },
                        { label: '11:00 PM', value: '23:00:00' },
                        { label: '11:30 PM', value: '23:30:00' },
                    ],
                    mapping: 'StartTime'
                  }
                ]
              },
              {
                fields: [
                  {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Interested in service?:',
              options: [
                { label: 'Pick-up', value: 'Pick-up' },
                { label: 'Full Buffet Service', value: 'Full Buffet Service' },
                { label: 'Delivery', value: 'Delivery' },
              ],
              mapping: 'bustype'
            }
          ]
        },
    {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Kalei\'s Kitchenette Contact Form',
    formId: '1848',
    clientKey: '61829B7C-4FD9-44C4-A046-81401750D12B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
